import { z } from 'zod/v4';
const DataSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.object({ fn: z.enum(['now']) }),
]);
export const FilterSchema = z.lazy(() => z.union([
    z.object({
        type: z.literal('and'),
        filters: z.array(FilterSchema).min(2),
    }),
    z.object({
        type: z.literal('or'),
        filters: z.array(FilterSchema).min(2),
    }),
    z.object({
        type: z.literal('not'),
        filter: FilterSchema,
    }),
    z.object({
        type: z.literal('in'),
        property: z.tuple([z.string(), z.string()]),
        values: z.array(DataSchema),
        path: z.array(z.string()).optional(),
        jsonKey: z.string().optional(),
    }),
    z.object({
        type: z.literal('eq'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('lt'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('lte'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('gt'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('gte'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('null'),
        property: z.tuple([z.string(), z.string()]),
        path: z.array(z.string()).optional(),
    }),
])); // Not great, but can't be inferred correctly this way
// Interpolated into generated SQL, so must never contain quotes or whitespace
const IdentifierSchema = z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/);
const SelectionSchema = z.object({
    fields: z.array(IdentifierSchema),
    markUnique: z.literal(true).optional(),
    filters: FilterSchema.nullish(),
    requiredPath: z.array(z.string()).optional(),
});
// TODO: Good schema, this lets lots of invalid stuff through
export const QuerySchema = z.object({
    properties: z.record(IdentifierSchema, SelectionSchema),
    scoped: z
        .record(IdentifierSchema, z.record(IdentifierSchema, SelectionSchema))
        .optional(),
    base: IdentifierSchema,
    orderBy: IdentifierSchema,
    orderByDirection: z.enum(['ASC', 'DESC']).optional(),
    filters: FilterSchema.nullable(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
//# sourceMappingURL=schema.js.map